import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { type Country } from './country.config';
import { CountryContext } from './country-context.service';

/** Route guard: blocks navigation when the current country does not match the required country. */
export function countryGuard(country: Country): CanActivateFn {
  return () => {
    if (inject(CountryContext).country === country) return true;
    return inject(Router).createUrlTree(['/']);
  };
}
